import { MissionsApi } from 'src/api';
import { ROUTES } from 'src/constants/routes.const';
import { stringifyUrl } from 'src/utils/stringifyUrl';

export type PathAiConversationSessionUrlOptions = {
  pathwayNodeId?: number;
  /** When true, omit pathway_node_id so completing the session does not advance the path. */
  forReview?: boolean;
};

/**
 * Uses today's recommended Membot mission (same source as Path hover previews
 * and /speak) and returns a direct /membot URL.
 */
export const getPathAiConversationSessionUrl = async (
  languagePairId: number,
  options: PathAiConversationSessionUrlOptions = {},
): Promise<string | null> => {
  const pathwayNodeId = options.forReview ? undefined : options.pathwayNodeId;

  const { mission } = await MissionsApi.getRecommendedMission(languagePairId);

  if (!mission) return null;

  return stringifyUrl(ROUTES.membot.dialog, {
    language_pair: languagePairId,
    slug: mission.locationSlug,
    source: 'path',
    back: ROUTES.path,
    ...(pathwayNodeId !== undefined ? { pathway_node_id: pathwayNodeId } : {}),
  });
};
